
@if (imgArr.length > 0){
    <div class="swiper" #swiper class="swiper-slide-show-screen">
        <div class="swiper-wrapper">
            <div *ngFor="let slide of imgArr; let i = index; let len = count" class="swiper-slide" [ngStyle]="slide.styles"></div>
        </div>
    </div> 
}
